import { render } from "./ItemConverter.vue?vue&type=template&id=1bae9a97&scoped=true"
import script from "./ItemConverter.vue?vue&type=script&lang=js"
export * from "./ItemConverter.vue?vue&type=script&lang=js"

import "./ItemConverter.vue?vue&type=style&index=0&id=1bae9a97&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bae9a97"]])

export default __exports__